export enum TableIcon {
	success = 'x_check',
	failed = 'x_cross',
	pending = 'o_pending',
}
